import { TypographyP2 } from '@heidi/design-system/typography';
import { Clock } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

/**
 * Subtle hint shown when a stream hasn't produced visible content for ~30s.
 * Helps users understand the delay is expected (e.g. during complex tool calls)
 * and that the system hasn't frozen. Automatically removed when the stream
 * completes or the timeout watcher aborts.
 */
export const StreamSlowHint = () => (
  <div className="flex items-center gap-1.5 animate-in fade-in duration-500">
    <Clock className="size-3.5 text-text-tertiary" />
    <TypographyP2 className="text-text-tertiary">
      <FormattedMessage
        defaultMessage="This is taking longer than usual…"
        id="chat.stream.slowHint"
      />
    </TypographyP2>
  </div>
);
